import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

interface ServerError {
  error: string;
  message: string;
  status: number;
  ok: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor() {}

  getClientMessage(error: Error): string {
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string {
    return error.stack;
  }

  getServerError(error: HttpErrorResponse): ServerError {
    return {
      error: error.error,
      message: error.message,
      status: error.status,
      ok: error.ok,
    };
  }
}
